import { useEffect, useRef, useState } from 'react'
import { useMyContext } from '../context/context'

export default function useWebsocketV2({ onMessage } = {}) {
  const [sequenceId, setSequenceId] = useState()

  const { eventId } = useMyContext()
  const ws = useRef(null)

  useEffect(() => {
    const host = window.location.hostname
    let wsBase = 'wss://ws.gayakoa.com/prod'
    if (host === 'localhost') wsBase = 'ws://localhost:5600'
    else if (host.includes('dev') || host.includes('d1cwsl2gmmbvf6.cloudfront.net')) wsBase = 'wss://ws.dev.gayakoa.com/dev'
    const websocketUrl = `${wsBase}?eventId=${eventId}`
    ws.current = new WebSocket(websocketUrl)

    ws.current.onmessage = event => {
      const result = JSON.parse(event.data)

      if (onMessage) {
        onMessage(result)
      }

      if (result.type === 'NEW_SEQUENCE') {
        setSequenceId(result.data.sequenceId)
      }
    }

    ws.current.onerror = error => {
      console.error('WebSocket error:', error)
    }

    return () => {
      return ws.current?.close()
    }
  }, [eventId, onMessage])

  return { sequenceId, socket: ws.current }
}
